export default __webpack_public_path__ + "static/media/ahc_at_center.5e7e0b2a.svg";